import React from 'react';
import PropTypes from 'prop-types';
import { primitives } from '@lexody/design-tokens';

import SideNavMenuCard from './SideNavMenuCard';
import SettingMenuItem from './SettingMenuItem';
import Icon from '../app_components/Icon';
import { LexicoinIllustration } from './SideNavIllustrations';

class SideNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      settingMenu: false,
    };

    this.toggleSettings = this.toggleSettings.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    this.setState({ settingMenu: false });
  }

  handleLogout = () => {
    const link = document.createElement('a');
    link.setAttribute('href', '../logout');
    link.setAttribute('rel', 'nofollow');
    link.setAttribute('data-method', 'delete');
    document.body.appendChild(link);
    link.click();
  };

  toggleSettings() {
    this.setState({ settingMenu: !this.state.settingMenu });
  }

  accentImage(key) {
    const images = this.props.accentImages || {};
    return images[key] || null;
  }

  renderHeader() {
    const { currentUserName, currentUserAvatar, currentUserStats, currentUserSlug } = this.props;
    const hasAvatar = currentUserAvatar && !currentUserAvatar.includes('missing');

    const goToProfile = () => window.location.replace(`../profile/${currentUserSlug}`);

    return (
      <div className="sideNav-header">
        <div
          className="sideNav-header__content sideNav-header__profileLink"
          onClick={goToProfile}
          role="link"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goToProfile();
            }
          }}
        >
          {hasAvatar ? (
            <img
              className="sideNav-header__avatar"
              src={currentUserAvatar}
              alt=""
            />
          ) : (
            <div className="sideNav-header__avatarPlaceholder">
              <Icon name="user" size={24} color="#fff" />
            </div>
          )}
          <div className="sideNav-header__info">
            <h2 className="sideNav-header__name">{currentUserName || 'Lexody'}</h2>
            {currentUserStats && (
              <p className="sideNav-header__stats">{currentUserStats}</p>
            )}
          </div>
        </div>
        <svg
          className="sideNav-header__wave"
          viewBox="0 0 400 28"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M0,14 C60,28 140,0 200,14 C260,28 340,0 400,14 L400,28 L0,28 Z"
            fill="#fff"
          />
        </svg>
      </div>
    );
  }

  renderSettingsMenu() {
    return (
      <div className="sideNav-settings">
        <button
          type="button"
          className="sideNav-settings__back"
          onClick={() => this.setState({ settingMenu: false })}
        >
          <Icon name="arrow-left" size={18} color={primitives.blue['600']} />
          Settings
        </button>
        <SettingMenuItem
          title="My Information"
          onClick={() => window.location.replace('../edit')}
        />
        <SettingMenuItem
          title="Languages"
          onClick={() => window.location.replace('../my_languages')}
        />
        <SettingMenuItem
          title="Who Can Contact Me"
          onClick={() => window.location.replace('../pro_settings')}
        />
        <SettingMenuItem
          title="Notifications"
          onClick={() => window.location.replace('../notification_settings')}
        />
      </div>
    );
  }

  renderMainMenu() {
    const { premiumUser } = this.props;

    return (
      <div className="sideNav-cards">
        <SideNavMenuCard
          variant="settings"
          icon="setting"
          iconColor={primitives.green['600']}
          title="SETTINGS"
          subtitle="Customize your experience"
          imageSrc={this.accentImage('settings')}
          onClick={() => this.toggleSettings()}
        />
        <SideNavMenuCard
          variant="membership"
          icon="award"
          iconColor={primitives.pink['600']}
          title="PRO MEMBERSHIP"
          subtitle="Unlock premium features"
          imageSrc={this.accentImage('membership')}
          onClick={() => window.location.replace('../pricing')}
        />
        <SideNavMenuCard
          variant="blog"
          icon="book-open"
          iconColor={primitives.orange['600']}
          title="BLOG - LANGUAGE RESOURCES"
          subtitle="Tips, guides, and language hacks"
          imageSrc={this.accentImage('blog')}
          onClick={() => window.location.replace('../blog')}
        />
        <SideNavMenuCard
          variant="support"
          icon="life-ring"
          iconColor={primitives.violet['700']}
          title="SUPPORT"
          subtitle="Get help and contact us"
          imageSrc={this.accentImage('support')}
          onClick={() => window.location.replace('../welcome/contact')}
        />
        <SideNavMenuCard
          variant="signout"
          icon="sign-out"
          iconColor={primitives.orange['700']}
          title="SIGN OUT"
          subtitle="See you soon!"
          imageSrc={this.accentImage('signOut')}
          onClick={this.handleLogout}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="sideNav-overlay" onClick={() => this.props.toggleMenu()}>
        <div
          className="sideNav-panel"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-label="Navigation menu"
        >
          <button
            type="button"
            className="sideNav-close"
            onClick={() => this.props.toggleMenu()}
            aria-label="Close menu"
          >
            <Icon name="times" size={20} color={primitives.blue['500']} />
          </button>
          <div className="sideNav-scroll">
            {this.state.settingMenu ? (
              this.renderSettingsMenu()
            ) : (
              <>
                {this.renderHeader()}
                {this.renderMainMenu()}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SideNav.propTypes = {
  currentUserSlug: PropTypes.string,
  currentUserAvatar: PropTypes.string,
  currentUserName: PropTypes.string,
  currentUserStats: PropTypes.string,
  premiumUser: PropTypes.bool,
  accentImages: PropTypes.shape({
    settings: PropTypes.string,
    membership: PropTypes.string,
    blog: PropTypes.string,
    support: PropTypes.string,
    signOut: PropTypes.string,
  }),
  toggleMenu: PropTypes.func.isRequired,
};

export default SideNav;
